import React from 'react'
import '../css/Featuredstories.css'

const Featuredstories = () => {
  return (
    <div>
        
    </div>
  )
}

export default Featuredstories